/**
 * Created by rathompson on 10/12/21
 * File: InheritedCellRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useContext, useMemo } from 'react'
import GlobalContext from '../../../../../../../common/context/GlobalContext'

/**
 *   Identity inheritance table cell
 */
const InheritedCellRenderer = ({ row }) => {

  const { treeReducer } = useContext(GlobalContext)
  const { sgKeyBy, selectedTreeNode } = treeReducer

  const sortedPolicies = useMemo(() => {
    const policies = row?.original?.policies
    return policies.sort((policy_a, policy_b) => {
      if (policy_a.inherited_from === selectedTreeNode?.id) {
        return -1
      }
      if (policy_b.inherited_from === selectedTreeNode?.id) {
        return 1
      }
      return policy_a.inherited_from - policy_b.inherited_from
    }, [])
  }, [row?.original?.policies, selectedTreeNode])

  const items = useMemo(() => {
    const tsgs = new Set()
    return sortedPolicies?.map(({ inherited_from }, index) => {
      const item = (
        <div key={index} className='tw-flex-1 tw-flex'>
          {inherited_from === selectedTreeNode?.id ? '' : (
            tsgs.has(inherited_from) ? '' : sgKeyBy?.[inherited_from]?.display_name || 'N/A'
          )}
        </div>
      )
      if (!tsgs.has(inherited_from)) {
        tsgs.add(inherited_from)
      }
      return item
    })
  }, [selectedTreeNode?.id, sgKeyBy, sortedPolicies])

  return (
    <div className='tw-flex tw-flex-col tw-gap-0.5 tw-h-full tw-w-full tw-p-1'>
      {items}
    </div>
  )
}

InheritedCellRenderer.propTypes = {}
export default InheritedCellRenderer
